var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--mingcute mnl__icon__root MuiBox-root css-cnvj7y",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.5 16.5a2 2 0 1 1 0 4a2 2 0 0 1 0-4m6.5 0a2 2 0 1 1 0 4a2 2 0 0 1 0-4m6.5 0a2 2 0 1 1 0 4a2 2 0 0 1 0-4M5.5 10a2 2 0 1 1 0 4a2 2 0 0 1 0-4m6.5 0a2 2 0 1 1 0 4a2 2 0 0 1 0-4m6.5 0a2 2 0 1 1 0 4a2 2 0 0 1 0-4m-13-6.5a2 2 0 1 1 0 4a2 2 0 0 1 0-4m6.5 0a2 2 0 1 1 0 4a2 2 0 0 1 0-4m6.5 0a2 2 0 1 1 0 4a2 2 0 0 1 0-4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.415b46125ee83b32b2ad11e13ebce55e.svg";
export { ForwardRef as ReactComponent };